import { Directive, TemplateRef, ViewContainerRef, computed, effect, inject, input } from "@angular/core";
import { Store } from "@ngxs/store";

import { LayoutState } from "../states/layout";

@Directive({
  selector: "[isHandset]",
})
export class IsHandset {
  readonly libIsHandset = input<boolean | "">(true);
  readonly libIsHandsetElse = input<TemplateRef<unknown> | null>(null);

  readonly #templateRef = inject(TemplateRef<unknown>);
  readonly #viewContainer = inject(ViewContainerRef);
  readonly #store = inject(Store);

  readonly #isHandset = this.#store.selectSignal(LayoutState.isHandset);

  readonly #shouldShow = computed(() => {
    const showOnHandset = this.#coerceBoolean(this.libIsHandset());
    const isHandset = this.#isHandset();

    return showOnHandset ? isHandset : !isHandset;
  });

  #currentView: "primary" | "else" | null = null;

  constructor() {
    effect(() => {
      const shouldShow = this.#shouldShow();
      const elseTemplate = this.libIsHandsetElse();

      if (shouldShow) {
        if (this.#currentView !== "primary") {
          this.#viewContainer.clear();
          this.#viewContainer.createEmbeddedView(this.#templateRef);
          this.#currentView = "primary";
        }
        return;
      }

      if (elseTemplate) {
        if (this.#currentView !== "else") {
          this.#viewContainer.clear();
          this.#viewContainer.createEmbeddedView(elseTemplate);
          this.#currentView = "else";
        }
        return;
      }

      if (this.#currentView !== null) {
        this.#viewContainer.clear();
        this.#currentView = null;
      }
    });
  }

  #coerceBoolean(value: unknown): boolean {
    if (value === "" || value === true || value == null) {
      return true;
    }

    if (value === false) {
      return false;
    }

    if (typeof value === "string") {
      return value.toLowerCase() === "true";
    }

    return Boolean(value);
  }
}
